
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { Dialog, Popup } from 'vant';
Vue.use(Popup).use(Dialog);
@Component
export default class Home extends Vue {
  tab1: any = [
    { url: require('../assets/wap/tab1.png'), type: 1 },
    { url: require('../assets/wap/tab2.png'), type: 3 },
    { url: require('../assets/wap/tab3.png'), type: 2 },
  ];
  tab2: any = [
    { url: require('../assets/wap/tab4.png'), type: 4 },
    { url: require('../assets/wap/tab5.png'), type: 5 },
  ];
  pointOut: boolean = false;
  async created() {}
  toSave(type: number) {
    if (window.udid) {
      this.$router.push(`save?type=${type}`);
    } else {
      this.$dialog
        .confirm({
          title: '友情提示',
          message: '请在上游新闻App参与',
          confirmButtonText: '还没装？一步安装',
          cancelButtonText: '我已安装过',
          closeOnClickOverlay: true,
        })
        .then((action) => {
          console.log(action);
          window.location.href = 'https://wap.cqcb.com/download';
        })
        .catch((action) => {
          console.log(action);
          if (action === 'overlay') {
            // 忽略掉点击遮罩层的关闭行为
            return;
          }
          if (isWeiXin()) {
            this.pointOut = true;
          } else {
            const openAndroidUrl =
              'https://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews&&android_schema=shangyounews://jump.cqcb.com/applink/jump.html';
            const openIosHmUrl = 'https://jump.cqcb.com/applink/jump.html';
            const data1 = '{"dt":"7","url":"' + document.location.href + '"}';
            if (window.isAndroid) {
              window.location.href = `${openAndroidUrl}?data=${data1}`;
            } else {
              window.location.href = `${openIosHmUrl}?data=${data1}`;
            }
          }
        });
    }
  }
}
